import React, { useState, useEffect } from 'react';
import * as ReactIcons from "react-icons/fa";
import { IconContext } from "react-icons";
import './styles.css';

const CategoryDetailDropdown = ({data, subCategory, setSelectedSubCategoryDetails, value}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [dataItems,  setDataItems] = useState([])

  useEffect(()=>{
    let subCatDetails = data?.SubCategory?.filter(item => item.subCategoryName === subCategory )
    setDataItems(...subCatDetails);
  },[data, subCategory])

  // useEffect(()=>{
  //   setSelectedSubCategoryDetails(selectedItem?.subCategoryDetailsName);
  // },[selectedItem]);


  const toggleDropdown = () => {  
    setIsOpen(!isOpen);
  };


  const handleItemClick = (item) => {
    setSelectedItem(item);
    setSelectedSubCategoryDetails(item?.subCategoryDetailsName);
    setIsOpen(false);
  };

  const IconComponent = ReactIcons["FaAngleDown"];
  
  return (
    <div className="dropdown-container">
      {console.log("isopen", isOpen)}
       <div className = "subcategory-container" onClick={toggleDropdown} >
          <div className="dropdown-header" >
            {console.log("selected itemin dropdown", selectedItem)}
            {value.length > 0 ? value : selectedItem ? selectedItem?.subCategoryDetailsName: 'Select'}
          </div>
          <div className="dropdown-icon-container">
            <IconContext.Provider
            value={{ color: "#588fe8", size: 15 }}
            >
            <IconComponent />
            </IconContext.Provider>
            </div>
        </div>
        {console.log("data iteeeee", dataItems)}
      {isOpen && dataItems ?  (
        <ul className="dropdown-menu">
          {  console.log("data items", dataItems)}
          {
            dataItems?.subCategoryDetails?.map((item) => { 
              console.log("items in map ", item)
              return  <li key={item?.id} onClick={() => handleItemClick(item)}>{item?.subCategoryDetailsName}</li>
            })
          }
        
        </ul>
      ) : null }
    </div>
  );
};

export default CategoryDetailDropdown;


